import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const Email = ({ t, validateEmail, emailError, emailValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const email = useSelector((state) => state.app.contactInformation.email)

  const handleEmail = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(changeObjectPropertyAction('contactInformation', 'email', name))
      validateEmail(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurEmail = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      dispatch(changeObjectPropertyAction('contactInformation', 'email', name))
      validateEmail(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <React.Fragment>
      <div className={[
        emailValid === true
          ? emailValid === ''
            ? ''
            : 'form-group has-success'
          : emailValid === false
            ? 'form-group has-error'
            : '',
        styles['fields_margin'],
      ].join(' ')}>
        <div className="ns-label-wrapper">
          <label className="ns-label" htmlFor="Email">
            {t('contact_info.email')}
          </label>
        </div>
        <div id="email-hint" className="ns-hint">
          {t('contact_info.your_confirmation')}
        </div>
        {(emailValid === true || emailValid === '') ? (
          null
        ) :
          (
            <span id="email-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
              <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
              <span className="ns-visually-hidden">{t('shared.error')}</span> {t(emailError)}
            </span>
          )}
        <div style={{ display: "flex", overflow: "auto" }}>
          <input className={[
            'fw-20',
            (emailValid === true) ? 'ns-input--success' : '',
            (emailValid !== true && emailValid !== '') ? 'ns-input--error' : ''].join(' ')}
            id="Email" name="Email" type="text"
            style={{ flexGrow: 1, minWidth: "3em" }}
            aria-describedby="email"
            onChange={handleEmail}
            onBlur={onBlurEmail}
            onFocus={() => SetIsFocussed(true)}
            value={email}
            autoComplete="off"
            maxLength="150" />
          {(emailValid === true) && (
            <div style={{ display: "inline-flex", marginLeft: "1rem", alignItems: "center" }}  ><i className="fa fa-check-circle fa-lg" aria-hidden="true"></i></div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(Email)